const conditionForEditWB = ({ username, roles, wbCreatedBy }) => {
  console.log(username, roles);
  console.log(wbCreatedBy);
  if (username === wbCreatedBy || roles.includes("Admin")) {
    return true;
  } else {
    return false;
  }
};
export { conditionForEditWB };
